<template functional>
    <div class="title-bar"
         :class="[props.barClass, {
            'fixed w-full': props.fixed
        }]"
    >
        <button
            :class="props.leftButtonClass"
            v-if="slots().leftIcon"
            @click="listeners['left-click']"
        >
            <slot name="leftIcon" />
        </button>

        <div
            v-if="props.title"
            class="text-center flex-1 font-semibold truncate"
            :class="{
                'ml-block': !slots().leftIcon,
                'mr-block': !slots().rightIcon,
                'text-xl flex items-center justify-center': !props.subtitle,
                'mt-2': props.subtitle,
            }">
            {{ props.title }}
            <div
                v-if="props.subtitle"
                class="text-center mt-1 text-xs">
                {{ props.subtitle }}
            </div>
        </div>

        <button
            :class="props.rightButtonClass"
            v-if="slots().rightIcon"
            @click="listeners['right-click']"
        >
            <slot name="rightIcon" />
        </button>
    </div>
</template>

<script>
    export default {
        props: {
            title: {
                type: String,
                default: null,
            },
            subtitle: {
                type: String,
                default: null,
            },
            leftButtonClass: {
                type: String,
                default: 'w-block h-block',
            },
            rightButtonClass: {
                type: String,
                default: 'w-block h-block',
            },
            barClass: {
                type: String,
                default: 'h-block bg-white border-b border-50 flex',
            },
            fixed: {
                type: Boolean,
                required: false,
                default: false,
            },
        },
    };
</script>
